var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgHelp = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Z",
    stroke: "currentColor",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.454 7.56s.039-.796.89-1.48c.505-.407 1.11-.525 1.656-.533.497-.007.94.076 1.206.202.454.216 1.34.745 1.34 1.868 0 1.182-.773 1.718-1.654 2.309-.88.59-1.12 1.231-1.12 1.893",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.855 14.844a.786.786 0 1 0 0-1.57.786.786 0 0 0 0 1.57Z",
    fill: "currentColor"
  })));
};

export { SvgHelp as ReactComponent };